import { ShieldAlert } from 'lucide-react'
import {
  StatCards,
  RecentPatientsWidget,
  AiAssistantWidget,
  QuickActionsWidget,
} from '@/components/features/dashboard'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'
import { useDashboardPage } from './DashboardPage.logic'

export function DashboardPage() {
  const { t, user, showSecurityBanner, dismissBanner, goToSecuritySettings } = useDashboardPage()

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold">{t('welcome', { name: user?.firstName || '' })}</h1>
        <p className="text-muted-foreground">{t('overview')}</p>
      </div>

      {showSecurityBanner && (
        <Alert className="border-amber-500/50 bg-amber-500/10 flex justify-between flex-wrap gap-4">
          <div className="flex items-center flex-column flex-wrap gap-2">
            <ShieldAlert className="size-4 text-amber-500" />
            <AlertTitle>{t('security.bannerTitle')}</AlertTitle>
            <AlertDescription>
              <span>{t('security.bannerDescription')}</span>
            </AlertDescription>
          </div>
          <div className="flex shrink-0 gap-2">
            <Button size="sm" variant="outline" onClick={goToSecuritySettings}>
              {t('security.activateNow')}
            </Button>
            <Button size="sm" variant="outline" onClick={dismissBanner}>
              ×
            </Button>
          </div>
        </Alert>
      )}

      <StatCards />

      <div className="grid grid-cols-1 items-start gap-6 lg:grid-cols-2">
        <div className="space-y-6">
          <AiAssistantWidget />
          <QuickActionsWidget />
        </div>

        <RecentPatientsWidget />
      </div>
    </div>
  )
}
